export const getDefaultLinesCollection = epsg => ({
  type: 'FeatureCollection',
  name: 'lines',
  crs: {
    type: 'name',
    properties: {
      code: epsg,
      name: 'urn:ogc:def:crs:EPSG::'+epsg
    }
  },
  features: []
});

export const getDefaultPolygonsCollection = epsg => ({
  type: 'FeatureCollection',
  name: 'polygons',
  crs: {
    type: 'name',
    properties: {
      code: epsg,
      name: 'urn:ogc:def:crs:EPSG::'+epsg
    }
  },
  features: []
});
export const getDefaultPointsCollection = epsg => ({
  type: 'FeatureCollection',
  name: 'points',
  crs: {
    type: 'name',
    properties: {
      code: epsg,
      name: 'urn:ogc:def:crs:EPSG::'+epsg
    }
  },
  features: []
});